import Vue from 'vue';
import _ from 'lodash';

// import moment from 'moment';

import sum from 'lodash/sum';
import feathersClient from '../../feathers-client';

const getUserProfileById = (id) => (id ? feathersClient.service(`/api/v3/users`).get(id) : null);
export const getUserProfileInfo = async (items) => {
    const usersInfo = {};
    const promises = items.map(async (id) => {
        const result = await getUserProfileById(id);
        if (!usersInfo[id]) {
            usersInfo[id] = {};
        }
        usersInfo[id].img = result?.imageUrl;
        usersInfo[id].firstName = result?.firstname;
        usersInfo[id].lastName = result?.lastname;
    });
    await Promise.allSettled(promises);
    return usersInfo;
};
const addUserInfoPreview = async (
    chat,
    currentUserId,
    setAvatars,
    setLoadedData,
    newMessage,
    initLoading,
) => {
    const copiedChat = initLoading ? chat : [chat];
    const profileIds = [];

    copiedChat.forEach((item, index) => {
        if (item.isGroupChat === false) {
            const previewImg = item?.participants.filter((id) => id !== currentUserId)[0];

            copiedChat[index].imgPreview = previewImg;
            profileIds.push(previewImg);
        } else if (item.isGroupChat === true && item?.id.indexOf('_') > 0) {
            const previewImg = item?.id.split('_')[0];
            copiedChat[index].imgPreview = previewImg;
            profileIds.push(previewImg);
        } else profileIds.push(null);

        if (item?.latestMessage?.senderId) {
            profileIds.push(item.latestMessage.senderId);
        }
    });

    const usersInfo = await getUserProfileInfo([...new Set(profileIds)]);
    setAvatars(usersInfo);

    copiedChat.forEach((item, index) => {
        const creatorId = item.id.split('_')[0];
        const otherUserIdFind = () => {
            if (!item.isGroupChat) {
                const filtered = item.participants.filter((userId) => userId !== currentUserId)[0] || null;
                return filtered;
            } if (item.jobId) {
                const nurseId = creatorId;
                return nurseId === currentUserId ? null : nurseId;
            } return null;
        };
        const otherUserId = otherUserIdFind();
        let itemTitle = '';
        let itemImg = null;
        if (item.isGroupChat) {
            if (item.jobId && otherUserId) {
                itemTitle = `${usersInfo[otherUserId]?.firstName || ''} ${usersInfo[otherUserId]?.lastName || ''}`;
                itemImg = usersInfo[otherUserId]?.img;
            } else if (usersInfo[creatorId]) {
                itemTitle = `${usersInfo[creatorId]?.firstName || ''} ${usersInfo[creatorId]?.lastName || ''}`;
                itemImg = usersInfo[creatorId]?.img;
            } else {
                itemTitle = item.chatTitle;
                itemImg = item.chatImage;
            }
        }

        if (otherUserId && usersInfo?.[otherUserId]) {
            itemTitle = `${usersInfo[otherUserId]?.firstName || ''} ${usersInfo[otherUserId]?.lastName || ''}`;
            itemImg = usersInfo[otherUserId]?.img;
        } else {
            itemTitle = item.chatTitle;
            itemImg = item.chatImage;
        }

        copiedChat[index].titleToShow = itemTitle;
        copiedChat[index].imgToShow = itemImg;
        copiedChat[index].renderId = `${copiedChat[index].id}refrshed`;
    });

    if (newMessage) {
        copiedChat.unshift(newMessage);
    }

    setLoadedData(copiedChat);
};

export default {
    namespaced: true,
    state: {
        messagesPreview: [],
        usersInfo: {},
        notifications: {},
        totalNotifications: 0,
        newMessageData: null,
        existingRoomId: null,
        searchUsersResult: [],
        selectedUserRow: [],
        data: {},
        chatLoading: false,
        loadingStash: [],
    },
    getters: {
        usersInfo: (state) => state.usersInfo,
        messagesPreview: (state) => state.messagesPreview,
        notifications: (state) => state.notifications,
        totalNotifications: (state) => state.totalNotifications,
        newMessageData: (state) => state.newMessageData,
        usersSearchResult: (state) => state.searchUsersResult,
        selectedUserRow: (state) => state.selectedUserRow,
        existingRoomId: (state) => state.existingRoomId,
        data: (state) => state.data,
    },
    mutations: {
        SET_DAYS_QUERY: (state, days) => { state.query.days = days; },
        SET_CHAT_LOADING: (state, value) => { state.chatLoading = value; },
        SET_USERS_INFO: (state, users) => { state.usersInfo = users; },
        ADD_USERS_INFO: (state, users) => { state.usersInfo = { ...state.usersInfo, ...users }; },
        SET_MESSAGES_PREVIEW: (state, messages) => { state.messagesPreview = messages; },
        ADD_MESSAGES_PREVIEW: (state, messages) => {
            if (messages.length === 1) {
                const newMessages = state.messagesPreview;
                const { id } = messages[0];
                const index = _.findIndex(newMessages, { id });
                if (index === -1) {
                    state.messagesPreview = [...messages, ...state.messagesPreview];
                    return;
                }
                newMessages.splice(index, 1);
                newMessages.unshift(messages[0]);
                state.messagesPreview = newMessages;
                return;
            }
            state.messagesPreview = [...messages, ...state.messagesPreview];
        },
        SPLICE_MESSAGES_PREVIEW: (state, data) => {
            const { id, message } = data;
            const messages = state.messagesPreview;
            const newMessages = state.messagesPreview;

            const index = _.findIndex(messages, { id });
            if(index >= 0) { // Avoid cases of room not found.
                const refreshedRoom = {
                    ...newMessages[index],
                //  latestMessage: { ...newMessages[index].latestMessage, ...message },
                };
                newMessages.splice(index, 1);
                newMessages.unshift(refreshedRoom);

                state.messagesPreview = newMessages;
            }
        },
        REFRESH_MESSAGES_PREVIEW: async (state, data) => {
            state.messagesPreview = data;
        },
        MOVE_STASH: (state) => {
            const { loadingStash, messagesPreview } = state;
            if (loadingStash.length > 0) {
                loadingStash.forEach((data) => {
                    const { id, latestMessage, profileId } = data;

                    const index = _.findIndex(messagesPreview, { id });

                    if (index === -1) {
                        messagesPreview.push(data);
                    } else {
                        const refreshedRoom = { ...messagesPreview[index], latestMessage };
                        const lastSeenDateChangedByCurrentuser = data[`lastSeenDate${profileId}`]?.seconds !== messagesPreview[index][`lastSeenDate${profileId}`]?.seconds;
                        if (!lastSeenDateChangedByCurrentuser) {
                            messagesPreview.splice(index, 1);
                            messagesPreview.unshift(refreshedRoom);
                        }
                    }
                });

                state.messagesPreview = messagesPreview;
            }
        },
        SET_NOTIFICATIONS: (state, notifications) => { state.notifications = notifications; },
        SET_TOTAL_NOTIFICATIONS: (state, totalNotifications) => {
            state.totalNotifications = totalNotifications;
        },
        SET_PRELOADED_AVATARS: (state, usersInfo) => {
            state.usersInfo = { ...state.usersInfo, ...usersInfo };
        },
        SET_NEW_MESSAGE_DATA: (state, newMessageData) => { state.newMessageData = newMessageData; },
        SET_SEARCH_USERS: (state, result) => { state.searchUsersResult = result; },
        SET_USER_ROW: (state, user) => { state.selectedUserRow = user; },
        SET_EXISTING_ROOM: (state, room) => { state.existingRoomId = room; },
    },
    actions: {
        setDaysQuery: ({ commit }, days) => {
            commit('SET_DAYS_QUERY', days);
        },
        setNewMessageData: ({ commit }, newMessageData) => {
            commit('SET_NEW_MESSAGE_DATA', newMessageData);
        },
        setSearchUsers: ({ commit }, result) => {
            commit('SET_SEARCH_USERS', result);
        },
        setUserRow: ({ commit }, user) => {
            commit('SET_USER_ROW', user);
        },
        clearNewMessageData: ({ commit }) => {
            commit('SET_NEW_MESSAGE_DATA', null);
        },
        setMessagesPreview: async ({ commit }, data) => {
            const { messages, currentUserId, newMessage } = data;
            commit('SET_CHAT_LOADING', true);
            const newMessages = messages.map((message) => ({ ...message, renderId: message.id }));
            if (newMessage) { newMessages.unshift(newMessage); }
            commit('SET_MESSAGES_PREVIEW', newMessages);
            await addUserInfoPreview(
                messages,
                currentUserId,
                (avatars) => commit('SET_PRELOADED_AVATARS', avatars),
                (messagesData) => commit('SET_MESSAGES_PREVIEW', messagesData),
                newMessage,
                true,
            );
            commit('SET_CHAT_LOADING', false);
            commit('MOVE_STASH');
        },
        addUserInfo: async ({ commit, state }, data) => {
            if (data.length === 0) return;
            const userIds = data;
            const { usersInfo } = state;
            const filteredData = userIds.filter((e) => !usersInfo?.[e]);
            if (filteredData.length > 0) {
                const newUserInfo = await getUserProfileInfo(userIds);
                commit('ADD_USERS_INFO', newUserInfo);
            }
        },
        spliceMessagesPreview: ({ commit }, data) => {
            commit('SPLICE_MESSAGES_PREVIEW', data);
        },
        refreshMessagesPreview: async ({ commit, state }, data) => {
            try {
                const {
                    id,
                    latestMessage,
                    profileId,
                 } = data;

                const newMessages = state.messagesPreview;
                const { chatLoading, loadingStash } = state;
                const container = chatLoading ? loadingStash : newMessages;

                const index = _.findIndex(container, { id });

                if (index === -1) {
                    if (chatLoading) {
                        container.push(data);
                    } else {
                        await addUserInfoPreview(
                            data,
                            profileId,
                            (avatars) => commit('SET_PRELOADED_AVATARS', avatars),
                            (messagesData) => commit('ADD_MESSAGES_PREVIEW', messagesData),
                            null,
                            false,
                        );
                        return;
                    }
                }
                const refreshedRoom = { ...container[index], latestMessage };
                const lastSeenDateChangedByCurrentuser = data[`lastSeenDate${profileId}`]?.seconds !== container[index][`lastSeenDate${profileId}`]?.seconds;

                if (!lastSeenDateChangedByCurrentuser) {
                    container.splice(index, 1);
                    container.unshift(refreshedRoom);
                }

                commit('REFRESH_MESSAGES_PREVIEW', newMessages);
            } catch (error) {
                throw Error(error);
            }
        },
        setNotifications: ({ commit }, notifications) => {
            commit('SET_NOTIFICATIONS', notifications);
            if(notifications){
                const notificationsCounter = sum(Object.values(notifications));
                commit('SET_TOTAL_NOTIFICATIONS', notificationsCounter);
            }
        },
        setUsersInfo: async () => {
        },
        setExistingRoomId: ({ commit }, room) => {
            commit('SET_EXISTING_ROOM', room);
        },
        clearExistingRoomId: ({ commit }, room) => {
            commit('SET_EXISTING_ROOM', room);
        },
    },
};